import * as React from "react";

import { ReactComponent as JapanMap } from "../../assets/japan-prefectures.svg";

function Location() {
  return (
    <section className="trps-section trps-dark" id="Location">
      <div className="trps-wrap">
        <h2 className="trps-h">活動拠点</h2>
        <p className="trps-sub">
          愛知県豊田市を拠点に、東京・大阪のメンバーともリモートで協力しながら活動しています。
        </p>

        <div className="trps-locmap">
          <div
            className="trps-japan"
            role="img"
            aria-label="東京、愛知、大阪を含む日本地図。愛知県を開発拠点、東京と大阪をリモート拠点として色分けしている。"
          >
            <JapanMap
              className="trps-japan__map"
              viewBox="300 575 380 240"
              aria-hidden="true"
              focusable="false"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Location;
